// routes/Dashboard.tsx — v38 ELINS interactive dashboard.
// Single intelligence surface composing global + regional + macro + entity.
// Server gates by ``v28_surfaces``; route is mounted under RequireAuth.

import DashboardRoot from "../components/dashboard/DashboardRoot";

export default function Dashboard() {
  return <DashboardRoot />;
}
